// extracted by mini-css-extract-plugin
export default {"Comments__button":"styles_Comments__button__QOyYF","Comments__button__text":"styles_Comments__button__text__hshB8","Comments__modal":"styles_Comments__modal__k5Ry3"};